// /pages/HR/components/kpis/LocationKPI.js
import React, { useState, useEffect } from 'react';
import './LocationKPI.css';

const LocationKPI = React.memo(({
  location = {},
  onClick = null,
  loading = false,
  animate = true
}) => {
  const [animatedValues, setAnimatedValues] = useState({
    completed: 0,
    open: 0
  });

  // Extract location data with defaults
  const {
    id = 'UNK',
    name = 'Unknown',
    icon = '📍',
    open = 0,
    completed = 0,
    trend = 0
  } = location;

  const total = open + completed;

  // Animate values on mount/change
  useEffect(() => {
    if (animate && !loading) {
      const duration = 1000;
      const steps = 20;
      const interval = duration / steps;

      let currentStep = 0;
      const timer = setInterval(() => {
        currentStep++;
        const progress = currentStep / steps;
        const easeOut = 1 - Math.pow(1 - progress, 3);

        setAnimatedValues({
          completed: Math.round(completed * easeOut),
          open: Math.round(open * easeOut)
        });

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, interval);

      return () => clearInterval(timer);
    } else {
      setAnimatedValues({ completed, open });
    }
  }, [completed, open, animate, loading]);

  const handleClick = () => {
    if (onClick) onClick(location);
  };

  return (
    <div
      className={`location-kpi ${onClick ? 'clickable' : ''} ${loading ? 'loading' : ''}`}
      onClick={handleClick}
      role={onClick ? 'button' : 'article'}
      tabIndex={onClick ? 0 : -1}
      data-location-id={id}
    >
      {/* Header Section */}
      <div className="location-header">
        <span className="location-icon">{icon}</span>
        <h4 className="location-name">{name}</h4>
        {trend !== 0 && (
          <span className={`location-trend ${trend > 0 ? 'positive' : 'negative'}`}>
            {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
          </span>
        )}
      </div>

      {/* Metrics Section */}
      <div className="location-metrics">
        <div className="metric-item">
          <span className="metric-value completed">{animatedValues.completed}</span>
          <span className="metric-label">Completed</span>
        </div>
        <div className="metric-item">
          <span className="metric-value open">{animatedValues.open}</span>
          <span className="metric-label">Open</span>
        </div>
      </div>

      {/* Total Section */}
      <div className="location-total">
        <span>Total: <strong>{total}</strong></span>
      </div>
    </div>
  );
});

LocationKPI.displayName = 'LocationKPI';

export default LocationKPI;
